module.exports = __webpack_public_path__ + "static/media/Artboard3.0a8fe11d.png";